<template>
  <div class="profile">
    <Header :showService="false" :showMinister="false" />

    <Content />

    <Footer />
  </div>
</template>

<script>
import Footer from "../../components/layout/Footer.vue";
import Header from "../../components/private/Header";
import Content from "./components/Content.vue";

export default {
  components: {
    Header,
    Content,
    Footer,
  },
  mounted() {
    this.$store.commit("setPrivateView", "comentarios");
  },
};
</script>

<style></style>
